import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Table,
  Button,
} from "reactstrap";
import axios from "axios";
import { APIURL, PORT } from "../../config/config";
import BDatePicker from "../BDatePicker";
import { saveAs } from "file-saver";
import Loading from "../Loading";
import { AlertError, AlertWarning } from "../Alert/Alert";
import { DateUtil } from "../../utils/dateUtil";
import {format} from "date-fns";

class CustomerFollowupReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      customer_types: [],
      followupDateStart: "",
      followupDateEnd: "",
      reportBy: "by_date",
      followupBy: "",
      status: "all",
      followupByOptions: [],
      customerFollowups: [],
      adminSocial: "",
      adminSocialOptions: [],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.loadCustomerTypes = this.loadCustomerTypes.bind(this);
    this.loadFollowupUserOptions = this.loadFollowupUserOptions.bind(this);
    this.loadAdminSocialOptions = this.loadAdminSocialOptions.bind(this);
  }

  componentDidMount() {
    // Set followupDateStart to first day of current month
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    // Format dates as YYYY-MM-DD for input fields
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // เดือนใน JavaScript เริ่มจาก 0
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const followupDateStart = formatDate(firstDayOfMonth);
    const followupDateEnd = formatDate(today);

    this.loadCustomerTypes();
    this.loadFollowupUserOptions();
    this.loadAdminSocialOptions();

    // Update state with date values
    this.setState(
      {
        followupDateStart: followupDateStart,
        followupDateEnd: followupDateEnd,
      },
      () => {
        // Call fetchReportData after state has been updated
        this.fetchReportData();
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.isReload !== prevProps.isReload) {
      this.fetchReportData();
    }
  }

  loadCustomerTypes() {
    axios
      .get(APIURL + "/customer/followup/customer_types") // Replace with your actual API endpoint
      .then((res) => {
        this.setState({ customer_types: res.data });
      })
      .catch((error) => {
        console.error("Error fetching customer types:", error);
        this.setState({ customer_types: [] });
      });
  }

  fetchReportData = () => {
    this.setState({ loading: true });

    const { followupDateStart, followupDateEnd, reportBy, followupBy, status, adminSocial } =
      this.state;

    // Construct query parameters based on selected filters
    let params = {};
    params.status = status;
    params.followupBy = followupBy;
    params.adminSocial = adminSocial;
    params.reportBy = reportBy;
    params.followupDateStart = "";
    params.followupDateEnd = "";

    if (followupDateStart && followupDateEnd && reportBy === "by_date") {
      params.followupDateStart = followupDateStart;
      params.followupDateEnd = followupDateEnd;
    }

    // if (status !== "all") {
    // }

    // Simulate API call
    axios
      .get(APIURL + "/customer/followup/report", { params }) // Replace with your actual API endpoint
      .then((res) => {
        this.setState({
          customerFollowups: res.data, // Assuming the API returns the report data in the response
          data: res.data, // Also save to data for Excel export
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching report data:", error);
        this.setState({ data: [], loading: false });
      });

    // Simulate API call
    // setTimeout(() => {
    //   const mockData = [
    //     {
    //       id: 1,
    //       customer: "ลูกค้า 1",
    //       telephone: "081-111-1111",
    //       status: "ติดต่อได้แล้ว",
    //       followupDate: "2023-10-15",
    //       notes: "บันทึก 1",
    //     },
    //     {
    //       id: 2,
    //       customer: "ลูกค้า 2",
    //       telephone: "082-222-2222",
    //       status: "รอติดต่อ",
    //       followupDate: "2023-10-16",
    //       notes: "บันทึก 2",
    //     },
    //   ;

    //   this.setState({
    //     data: mockData,
    //     loading: false,
    //   });
    // }, 1000);
  };

  handleExportExcel = () => {
    const { customerFollowups } = this.state;

    // ถ้าไม่มีข้อมูล ไม่ต้อง export
    if (!customerFollowups || customerFollowups.length === 0) {
      AlertWarning("ไม่มีข้อมูลที่จะส่งออก");
      return;
    }
    this.setState({
      isLoading: true,
    });

    // สร้าง workbook ใหม่
    const ExcelJS = require("exceljs/dist/exceljs");
    const workbook = new ExcelJS.Workbook();

    // สร้าง worksheet
    const worksheet = workbook.addWorksheet("รายงานการติดตามลูกค้า");

    // กำหนด columns
    let columns = [
      { header: "ลำดับ", key: "no", width: 6 },
      { header: "ชื่อลูกค้า", key: "customer", width: 30 },
      { header: "เบอร์โทร", key: "telephone", width: 15 },
      { header: "สถานะการติดต่อล่าสุด", key: "status", width: 20 },
      { header: "วันที่ติดต่อล่าสุด", key: "contactDate", width: 15 },
      { header: "วันที่นัดหมาย", key: "appointmentDate", width: 15 },
      { header: "ติดตามโดย", key: "followupBy", width: 15 },
    ];

    // Add admin_social column only for PORT 9064 or 9000
    if (PORT === 9064) {
      columns.push({ header: "ลูกค้าจากแอดมิน", key: "adminSocial", width: 15 });
    }

    columns.push({ header: "หมายเหตุ", key: "notes", width: 30 });

    worksheet.columns = columns;

    // จัดรูปแบบ header row
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = {
      vertical: "middle",
      horizontal: "center",
    };

    // เพิ่มข้อมูลลงใน worksheet
    customerFollowups.forEach((item, index) => {
      let rowData = {
        no: index + 1,
        customer: item.customer_name + " " + item.customer_lastname,
        telephone: item.customer_mobile,
        status: item.customer_type_name,
        contactDate: DateUtil.convertLongDateThai(item.contact_date),
        appointmentDate: DateUtil.convertLongDateThai(item.followup_date),
        followupBy: item.followup_by,
      };

      // Add admin_social data only for PORT 9064 or 9000
      if (PORT === 9064) {
        rowData.adminSocial = item.admin_social || "ไม่ระบุ";
      }

      rowData.notes = item.customer_note;

      worksheet.addRow(rowData);
    });

    // ตั้งค่าความกว้างของคอลัมน์ให้พอดีกับเนื้อหา (auto fit)
    worksheet.columns.forEach((column) => {
      const lengths = column.values
        .filter((v) => v)
        .map((v) => v.toString().length);
      const maxLength = Math.max(
        ...lengths.filter(Boolean),
        column.header.length
      );
      column.width = maxLength + 2;
    });

    // Export ไฟล์ Excel
    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        // สร้างชื่อไฟล์จากวันที่ปัจจุบัน
        const today = new Date();
        const fileName = `รายงานการติดตามลูกค้า_${today.getFullYear()}-${(
          today.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${today
          .getDate()
          .toString()
          .padStart(2, "0")}.xlsx`;

        // สร้าง blob และบันทึกไฟล์
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName);

        setTimeout(() => {
          this.setState({
            isLoading: false,
          });
        }, 1500);
      })
      .catch((err) => {
        console.error("Error exporting Excel:", err);
        this.setState({
          isLoading: false,
        });
        AlertError("เกิดข้อผิดพลาดในการส่งออกไฟล์ Excel");
      });
  };

  // handlePrint = () => {
  //   // console.log("Print report");
  // };

  searchCustomerFollowUp = () => {
    // console.log("search  searchCustomerFollowUp");
    this.fetchReportData();
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "radio" ? target.value : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  loadFollowupUserOptions() {
    axios
      .get(APIURL + "/account/")
      .then((res) => {
        let accounts = res.data;
        let options = [];
        if (accounts && accounts.length > 0) {
          options = accounts
            .map((acc) => {
              // IMPORTANT: Adjust these field names based on your 'account' data structure
              // 'acc.user' should be the value stored in customer.followup_by
              // 'acc.name' or 'acc.display_name' should be the display name
              const displayName = acc.name || acc.display_name || acc.user; // Choose best available display name
              const userValue = acc.user; // This must match what's in customer.followup_by

              return {
                name: displayName,
                value: userValue,
              };
            })
            .filter((opt) => opt.value); // Ensure options have a value
        }

        // Add the "All" option at the beginning
        this.setState({
          followupByOptions: [
            { name: "ผู้ติดตามทั้งหมด", value: "" },
            ...options,
          ],
        });
      })
      .catch((error) => {
        console.error("Error loading followup user options:", error);
        this.setState({
          followupByOptions: [{ name: "ผู้ติดตามทั้งหมด", value: "" }], // Fallback
        });
      });
  }

  loadAdminSocialOptions() {
    axios
      .get(APIURL + "/account/type/adminsocial")
      .then((res) => {
        let accounts = res.data;
        let options = [];
        if (accounts && accounts.length > 0) {
          options = accounts
            .map((acc) => {
              const displayName = acc.fullname || acc.name || acc.display_name || acc.user;
              const userValue = acc.user;

              return {
                name: displayName,
                value: userValue,
              };
            })
            .filter((opt) => opt.value);
        }

        // Add the "All" option at the beginning
        this.setState({
          adminSocialOptions: [
            { name: "ลูกค้าจากแอดมินทั้งหมด", value: "" },
            ...options,
          ],
        });
      })
      .catch((error) => {
        console.error("Error loading admin social options:", error);
        this.setState({
          adminSocialOptions: [{ name: "ลูกค้าจากแอดมินทั้งหมด", value: "" }],
        });
      });
  }

  render() {
    const {
      loading,
      customerFollowups,
      customer_types,
      followupDateStart,
      followupDateEnd,
      reportBy,
      followupBy,
      status,
      followupByOptions,
      adminSocial,
      adminSocialOptions,
    } = this.state;
    return (
        <div className="row" style={styles.overflowY}>
          <Loading isLoading={this.state.isLoading} />

          <div className="card-block">
            <div className="card card-accent-primary">
                <div className="card-header">
                  <div className="row col-12 mt-1">
                    <div className="col-6">
                      <strong className="text-title">
                        รายงานการติดตามลูกค้า
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="card-block">
                  <div className="row col-12 mt-1">
                    <div className="mt-1 ml-4 mr-2">ตามวันที่ติดตาม:</div>
                    <div className="form-group col-2 ml-2">
                      <BDatePicker
                          isDateFill={0}
                          //className="ml-2"
                          name={"followupDateStart"}
                          value={followupDateStart}
                          label={""}
                          disable={reportBy === "by_all"}
                          onUpdateDate={(buddhist_date, christ_date) => {
                            this.setState({
                              followupDateStart: christ_date,
                            });
                          }}
                      />
                    </div>
                    <span className="mt-1">ถึง</span>
                    <div className="form-group col-2">
                      <BDatePicker
                          isDateFill={0}
                          //className="form-control d-inline-block ml-2 mr-3"
                          name={"followupDateEnd"}
                          value={followupDateEnd}
                          disable={reportBy === "by_all"}
                          label={""}
                          onUpdateDate={(buddhist_date, christ_date) => {
                            this.setState({
                              followupDateEnd: christ_date,
                            });
                          }}
                      />
                    </div>
                    <div className="mr-3 ml-3">
                      <label
                          htmlFor="reportBy"
                          className="d-flex align-items-center mb-0"
                      >
                        <input
                            type="radio"
                            name="reportBy"
                            value="by_date"
                            id="by_date"
                            className="mr-1"
                            checked={reportBy === "by_date"}
                            onChange={this.handleInputChange}
                        />
                        <span>ตามวันที่</span>
                      </label>
                    </div>
                    <div className="mr-3">
                      <label
                          htmlFor="reportBy"
                          className="d-flex align-items-center mb-0"
                      >
                        <input
                            type="radio"
                            name="reportBy"
                            value="by_all"
                            id="by_all"
                            className="mr-1"
                            checked={reportBy === "by_all"}
                            onChange={this.handleInputChange}
                        />
                        <span>ทั้งหมด</span>
                      </label>
                    </div>

                    {/*TODO:เพิ่มการค้นหาจาก ลูกค้าจากแอดมิน*/}
                    {(PORT === 9064) && (
                        <div className="form-group mr-2">
                          <select
                              name="adminSocial"
                              className="form-control"
                              value={adminSocial}
                              onChange={this.handleInputChange}
                          >
                            {adminSocialOptions.length > 0 &&
                            adminSocialOptions.map((sale, index) => (
                                <option key={index} value={sale.value}>
                                  {sale.name}
                                </option> // Replace with actual user id/name
                            ))}
                          </select>
                        </div>
                    )}

                    <div className="form-group">
                      <select
                          name="followupBy"
                          className="form-control"
                          value={followupBy}
                          onChange={this.handleInputChange}
                      >
                        {followupByOptions.length > 0 &&
                        followupByOptions.map((sale, index) => (
                            <option key={index} value={sale.value}>
                              {sale.name}
                            </option> // Replace with actual user id/name
                        ))}
                      </select>
                    </div>

                    <div className="ml-3 mb-2">
                      <Button
                          className="mr-1 mb-2"
                          color="primary"
                          onClick={this.searchCustomerFollowUp}
                      >
                        ค้นหา
                      </Button>
                      <Button
                          className="mb-2"
                          color="success"
                          onClick={this.handleExportExcel}
                      >
                        Excel
                      </Button>
                    </div>
                  </div>

                  <div className="row ml-4 mt-1 mb-2">
                    <div className="d-flex align-items-center mb-0">
                      <span> สถานะการติดตาม: </span>
                      <div className="mr-3 ml-3">
                        <label
                            className="d-flex align-items-center mb-0"
                            htmlFor="all"
                        >
                          <input
                              className="mr-1"
                              type="radio"
                              name="status"
                              id="all"
                              value="all"
                              checked={status === "all"}
                              onChange={this.handleInputChange}
                          />
                          <span> ทั้งหมด </span>
                        </label>
                      </div>
                      {customer_types.map((customer_type, index) => (
                          <div className="mr-3" key={index}>
                            <label
                                className="d-flex align-items-center mb-0"
                                htmlFor={customer_type.customer_type}
                            >
                              <input
                                  className="mr-1"
                                  type="radio"
                                  name="status"
                                  id={customer_type.customer_type}
                                  value={customer_type.customer_type}
                                  checked={status === customer_type.customer_type}
                                  onChange={this.handleInputChange}
                              />
                              <span> {customer_type.customer_type_name} </span>
                            </label>
                          </div>
                      ))}
                    </div>
                  </div>

                  <div className="row mt-1">
                    <div className="col-12">
                      <table className="table table-striped table-responsive">
                        <thead>
                        <tr>
                          <th style={{ width: 10 }}>ลำดับ</th>
                          <th className="text-center">ชื่อลูกค้า </th>
                          <th className="text-center text-nowrap">
                            เบอร์โทรศัพท์
                          </th>
                          <th
                              className="text-center text-nowrap"
                              style={{ minWidth: 150 }}
                          >
                            สถานะการติดต่อล่าสุด
                          </th>
                          <th className="text-center text-nowrap">
                            วันที่ติดต่อล่าสุด
                          </th>
                          <th className="text-center text-nowrap">
                            วันที่นัดหมาย
                          </th>
                          <th className="text-center text-nowrap">ติดตามโดย</th>
                          {(PORT === 9064) && (
                              <th className="text-center text-nowrap">ลูกค้าจากแอดมิน</th>
                          )}
                          <th
                              className="text-center text-nowrap"
                              style={{ minWidth: 250 }}
                          >
                            หมายเหตุ
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        {loading ? (
                            <tr>
                              <td colSpan={PORT === 9064 ? 9 : 8} className="text-center">
                                กำลังโหลดข้อมูล...
                              </td>
                            </tr>
                        ) : customerFollowups.length === 0 ? (
                            <tr>
                              <td colSpan={PORT === 9064 ? 9 : 8} className="text-center">
                                ไม่พบข้อมูล
                              </td>
                            </tr>
                        ) : (
                            customerFollowups.map((customer, index) => (
                                <tr key={index}>
                                  <td className="text-center">{index + 1}</td>
                                  <td>
                                    {customer.customer_name +
                                    " " +
                                    customer.customer_lastname}
                                  </td>
                                  <td>{customer.customer_mobile}</td>
                                  <td>{customer.customer_type_name}</td>
                                  <td className="text-nowrap">
                                    {DateUtil.convertLongDateThai(
                                        customer.contact_date
                                    )}
                                  </td>
                                  <td className="text-nowrap">
                                    {DateUtil.convertLongDateThai(
                                        customer.followup_date
                                    )}
                                  </td>
                                  <td>{customer.followup_by}</td>
                                  {(PORT === 9064) && (
                                      <td>{customer.admin_social || "ไม่ระบุ"}</td>
                                  )}
                                  <td>{customer.customer_note}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
    );
  }
}

const styles = {
  overflowY: {
    overflow: "scroll",
  },
};

export default CustomerFollowupReport;
